.tooltip {
  max-width: calc(var(--mirai-ui-breakpoint-S) * 0.8);
  gap: var(--mirai-ui-space-XS);
}

.tooltip .included {
  gap: var(--mirai-ui-space-XXS);
}

.tooltip .included ui-text {
  color: var(--mirai-ui-base);
}

.tooltip .row {
  align-items: flex-start;
}

.row {
  align-items: flex-start;
  gap: var(--mirai-ui-space-XXS);
}

.row.centered {
  align-items: center;
}

/* S */
@media only screen and (max-width: 480px) {
  .content {
    margin-top: calc(var(--mirai-ui-space-XXS) / 2);
    gap: calc(var(--mirai-ui-space-XXS) / 2);
  }
  .row ui-text {
    margin-top: calc(var(--mirai-ui-space-XXS) / 2);
  }
}

/* M & L */
@media only screen and (min-width: 481px) {
  .content {
    margin-top: var(--mirai-ui-space-XXS);
    gap: var(--mirai-ui-space-XXS);
  }
}
